/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */
/* eslint-disable */

import React, { useCallback, useState, useEffect } from "react";
import { withRouter } from "react-router";
import clsx from "clsx";
//	TODO: Change Imports and styles

import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Alert as MuiAlert } from "@mui/material";
import Snackbar from "@material-ui/core/Snackbar";
import { Close } from "@mui/icons-material";
import IconButton from "@material-ui/core/IconButton";
import HeaderTemplate from "./template/Header/Header";
import FooterTemplate from "./template/Footer";
import SideBarConfig from "../configs/SideBarConfig";
import HeaderStyles from "../theme/headerStyles";
import drawerSideBarMenuStyles from "../theme/drawerSideBarMenuStyles";
import { actions as AppActions, getNotificationStatus, getSideBarIsOpened } from "../reducers/app";
import STATIC_ROUTES from "../route/STATIC_ROUTES";
import Routes from "../routes";

interface Props {
  classes: Object;
  children: Object;
  isSideBarIsOpened: boolean;
  isAuthenticated: boolean;
  notificationStatus: Object;
  hideNotifications: () => void;
}

function Alert(props) {
  return (
    <MuiAlert
      elevation={6}
      variant="filled"
      {...props}
      sx={{
        fontSize: "25px",
        fontWeight: "400",
        alignItems: "center",
        "& .MuiSvgIcon-root": { fontSize: "22px", padding: "7px" },
      }}
    />
  );
}

const pathname = window.location.pathname;

const App = React.memo((props: Props) => {
  const { user } = props;

  const isSwipeDrawer = SideBarConfig.config.isSwipeableDrawer;
  let useStyles = null;
  if (user) {
    useStyles = isSwipeDrawer ? makeStyles(HeaderStyles) : makeStyles(drawerSideBarMenuStyles);
  } else {
    useStyles = makeStyles(HeaderStyles);
  }

  const classes = useStyles();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);

  const {
    isSideBarIsOpened,
    notificationStatus,
    // isAuthenticated
  } = useSelector((globalState) => ({
    isSideBarIsOpened: getSideBarIsOpened(globalState),
    notificationStatus: getNotificationStatus(globalState),
  }));

  // const [windowWidth, setWindowWidth] = useState(0);
  // const [windowHeight, setWindowHeight] = useState(0);
  // const resizeWindow = () => {
  //   setWindowWidth(window.innerWidth);
  //   setWindowHeight(window.innerHeight);
  // };

  // useEffect(() => {
  //   resizeWindow();
  //   window.addEventListener('resize', resizeWindow);
  //   return () => window.removeEventListener('resize', resizeWindow);
  // }, []);
  //

  useEffect(() => {
    if (notificationStatus && notificationStatus.visible === true) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [notificationStatus]);

  // function getSideBarCSSContent() {
  //   if (
  //     STATIC_ROUTES.login !== pathname &&
  //     STATIC_ROUTES.landingPage !== pathname &&
  //     STATIC_ROUTES.signup !== pathname &&
  //     STATIC_ROUTES.logout !== pathname &&
  //     STATIC_ROUTES.profile !== pathname &&
  //     STATIC_ROUTES.errorPage !== pathname
  //   ) {
  //     return clsx(classes.content, {
  //       [classes.contentShift]: isSideBarIsOpened,
  //     });
  //   }
  //   return classes.root;
  // }

  const hideNotify = useCallback(
    (event, reason) => {
      if (reason === "clickaway") {
        setOpen(false);
        return;
      }

      dispatch(AppActions.hideNotifications);
      if (notificationStatus && notificationStatus.visible === false) {
        setOpen(false);
      }
    },
    [dispatch]
  );

  const isMobile = window.innerWidth <= 768;

  // console.log('windowWidth: ', windowWidth);
  // console.log('windowHeight: ', windowHeight);
  // console.log('isMobile: ', isMobile);
  // console.log('isAuthenticated: ', isAuthenticated);
  // const routes = useRoutes(isAuthenticated ? PrivateRoutes(props) : PublicRoutes(props));

  return (
    <div>
      <HeaderTemplate logo="LOGO*" isMobile={isMobile} {...props} />

      {/* <main className={getSideBarCSSContent()}> */}
      <main>
        {/* {routes} */}
        <Routes {...props} user={user} />
      </main>
      <FooterTemplate isMobile={isMobile} />
      {notificationStatus.severity === null || notificationStatus.severity === "" ? (
        <Snackbar
          open={open}
          onClose={() => hideNotify()}
          className={classes.snackBar}
          autoHideDuration={notificationStatus.autohide ? 10000 : 10000}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={
            <span id="message-id" className={classes.alerMessage}>
              {notificationStatus.text}
            </span>
          }
          action={[
            <IconButton key="close" aria-label="Close" color="inherit" onClick={() => hideNotify()}>
              <Close />
            </IconButton>,
          ]}
        />
      ) : (
        <Snackbar
          open={open}
          onClose={() => hideNotify()}
          className={classes.snackBar}
          autoHideDuration={notificationStatus.autohide ? 7000 : 7000}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          action={[
            <IconButton key="close" aria-label="Close" color="inherit" onClick={() => hideNotify()}>
              <Close />
            </IconButton>,
          ]}
        >
          <Alert
            id="message-id"
            className={classes.alerMessage}
            severity={notificationStatus.severity}
            onClose={() => hideNotify()}
          >
            {notificationStatus.text}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
});

export default withRouter(App);
